import React from 'react';
import { OidcSecure } from '@axa-fr/react-oidc';

/** Wrapper around OidcSecure for exposing to apps */
const AuthWrapper = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}): JSX.Element => <OidcSecure>{children}</OidcSecure>;

export default AuthWrapper;
